import 'ace-builds/src-noconflict/ext-elastic_tabstops_lite';
import 'ace-builds/src-noconflict/ext-error_marker';
import 'ace-builds/src-noconflict/ext-keybinding_menu';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/ext-options';
import 'ace-builds/src-noconflict/ext-prompt';
import 'ace-builds/src-noconflict/ext-rtl';
import 'ace-builds/src-noconflict/ext-searchbox';
import 'ace-builds/src-noconflict/ext-static_highlight';
import 'ace-builds/src-noconflict/keybinding-vim';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/theme-chaos';
import 'ace-builds/src-noconflict/snippets/html';

export default {
  WebsiteTemplateDesignerHtmlEditor: {
    mounted() {
      const editorContainer = this.el.querySelector('#editor');
      const formInput = this.el.querySelector('textarea.hidden-input');
      const editor = window.ace.edit(editorContainer, {
        mode: 'ace/mode/html',
        theme: 'ace/theme/chaos',
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: true,
        fontSize: 12,
        maxLines: 100,
        minLines: 50,
        tabSize: 2,
        useSoftTabs: true,
        useWorker: false,
      });

      editorContainer.classList.remove('is-hidden');

      // Enable Vim mode if URL contains `#usevim` fragment
      if (window.location.hash === '#usevim') {
        editor.setKeyboardHandler('ace/keyboard/vim');
        editor.setOption('relativeLineNumbers', true);
      }

      editor.commands.addCommands([
        {
          name: 'save',
          bindKey: { win: 'Ctrl-S', mac: 'Command-S' },
          exec: () => {
            this.el.closest('form').querySelector('button.button').click();
          },
        },
        {
          name: 'showKeyboardShortcuts',
          bindKey: { win: 'Ctrl-,', mac: 'Command-,' },
          exec: (e) => {
            window.ace.config.loadModule('ace/ext/keybinding_menu', (module) => {
              module.init(e);
              e.showKeyboardShortcuts();
            });
          },
        },
      ]);

      editor.on('input', () => {
        formInput.value = editor.getValue();
      });
    },
  },
};
